export default __webpack_public_path__ + "static/media/sign_up_success.f634b680.svg";